import { useEffect, useRef, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import visibleImg from "../../../../../picture/Visible.png";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";

const styles = {
  cell: { padding: "5px", textAlign: "center", fontSize: "14px" },
  button: { padding: "10px 30px" }
};

// Modal za prikaz detalja iz kataloga
function LzoDetaljiModal({ item, baseUrl, onClose }) {
  if (!item) return null;
  const slikaUrl = item.slika_path
  ? `${baseUrl.replace('/api', '')}${item.slika_path}`
  : null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 1000
    }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "30px", width: "500px", maxHeight: "80vh", overflowY: "auto" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "15px" }}>{item.naziv}</div>
        {slikaUrl && (
          <img src={slikaUrl} alt={item.naziv}
            style={{ width: "100%", maxHeight: "200px", objectFit: "contain", marginBottom: "15px", border: "1px solid #eee" }} />
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "14px" }}>
          <div><span style={{ fontWeight: "bold" }}>Kategorija: </span>{item.kategorija}</div>
          <div><span style={{ fontWeight: "bold" }}>Standard: </span>{item.standard}</div>
          <div><span style={{ fontWeight: "bold" }}>Namena: </span>{item.namena}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
          <div onClick={onClose}><Button activation={true} style={styles.button}>ZATVORI</Button></div>
        </div>
      </div>
    </div>
  );
}

// Modal za unos količina pre dodavanja
function KolicineModal({ selectedItems, onConfirm, onClose }) {
  const [kolicine, setKolicine] = useState(() =>
    selectedItems.reduce((acc, item) => ({
      ...acc,
      [String(item.id)]: { izd: "", mag: "", otp: "" }
    }), {})
  );

  const handleChange = (id, field, value) => {
    if (value !== "" && !/^\d+$/.test(value)) return;
    setKolicine(prev => ({ ...prev, [String(id)]: { ...prev[String(id)], [field]: value } }));
  };

  const handleConfirm = () => {
    const normalized = Object.fromEntries(
      Object.entries(kolicine).map(([id, vals]) => [
        id,
        {
          izd: parseInt(vals.izd) || 0,
          mag: parseInt(vals.mag) || 0,
          otp: parseInt(vals.otp) || 0,
        }
      ])
    );
    onConfirm(normalized);
  };

  const inputStyle = { width: "60px", height: "32px", textAlign: "center", fontSize: "14px", padding: "0 4px" };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)", display: "flex",
      justifyContent: "center", alignItems: "center", zIndex: 1000
    }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", padding: "30px", width: "620px", maxHeight: "80vh", overflowY: "auto" }}>
        <div style={{ fontWeight: "bold", fontSize: "15px", marginBottom: "20px" }}>Unesi početne količine</div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ ...styles.cell, textAlign: "left" }}>LZO</th>
              <th style={styles.cell}>IZD</th>
              <th style={styles.cell}>MAG</th>
              <th style={styles.cell}>OTP</th>
            </tr>
          </thead>
          <tbody>
            {selectedItems.map(item => (
              <tr key={item.id} style={{ borderTop: "1px solid #eee" }}>
                <td style={{ ...styles.cell, textAlign: "left", paddingLeft: "8px" }}>{item.naziv}</td>
                <td style={styles.cell}>
                  <input value={kolicine[String(item.id)]?.izd ?? ""} placeholder="0"
                    onChange={e => handleChange(item.id, "izd", e.target.value)} style={inputStyle} />
                </td>
                <td style={styles.cell}>
                  <input value={kolicine[String(item.id)]?.mag ?? ""} placeholder="0"
                    onChange={e => handleChange(item.id, "mag", e.target.value)} style={inputStyle} />
                </td>
                <td style={styles.cell}>
                  <input value={kolicine[String(item.id)]?.otp ?? ""} placeholder="0"
                    onChange={e => handleChange(item.id, "otp", e.target.value)} style={inputStyle} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
          <div onClick={onClose}><Button activation={true} style={styles.button}>ODUSTANI</Button></div>
          <div onClick={handleConfirm}><Button activation={true} style={styles.button}>DODAJ U FIRMU</Button></div>
        </div>
      </div>
    </div>
  );
}

function DodavanjePostojeciTabela() {
  const [allData, setAllData] = useState([]);
  const [kategorije, setKategorije] = useState([]);
  const [selectedKategorija, setSelectedKategorija] = useState("");
  const [search, setSearch] = useState("");
  const [checkedIds, setCheckedIds] = useState([]);
  const [detaljiItem, setDetaljiItem] = useState(null);
  const [showKolicine, setShowKolicine] = useState(false);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const rowRefs = useRef({});

  const { setFolderDokumentCurrentState, selectedMainEntity, baseUrl, lzoScrollToId, setLzoScrollToId } = useGlobalContext();

  // Scroll na red kad showbar klikne stavku
  useEffect(() => {
    if (!lzoScrollToId) return;
    const el = rowRefs.current[lzoScrollToId];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.style.backgroundColor = "#fff9c4";
      setTimeout(() => { el.style.backgroundColor = ""; }, 1500);
    }
    setLzoScrollToId(null);
  }, [lzoScrollToId]);

  const fetchKatalog = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/lzo_katalog/read.php`, {
        search, kategorija: selectedKategorija
      });
      if (data.status === 200) {
        setAllData(data.data);
        setKategorije(data.kategorije);
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetchKatalog(); }, [search, selectedKategorija]);

  const handleCheckRow = (id) => {
    setCheckedIds(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
  };

  const handleDodajKlik = () => {
    if (checkedIds.length === 0) return;
    setShowKolicine(true);
  };

  const handleConfirmKolicine = async (kolicine) => {
    setLoading(true);
    setShowKolicine(false);
    try {
      await Promise.all(checkedIds.map(katalog_id => {
        const k = kolicine[String(katalog_id)] || { izd: 0, mag: 0, otp: 0 };
        return axios.post(`${baseUrl}/lzo_katalog/addFromKatalog.php`, {
          company_id: selectedMainEntity.company_id,
          lzo_katalog_id: katalog_id,
          izd: parseInt(k.izd) || 0,
          mag: parseInt(k.mag) || 0,
          otp: parseInt(k.otp) || 0,
        });
      }));
      setFolderDokumentCurrentState("");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const selectedItems = allData.filter(d => checkedIds.includes(d.id));

  return (
    <div style={{ padding: "20px", fontSize: "14px", height: "100%", width: "100%", backgroundColor: "#F9F9F9" }}>
      <style>{`#katalog-tabela td, #katalog-tabela th { font-size: 14px !important; }`}</style>

      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <input placeholder="Pretraži..." value={search} onChange={e => setSearch(e.target.value)}
          style={{ height: "36px", padding: "0 10px", fontSize: "14px", flex: 1 }} />
        <select value={selectedKategorija} onChange={e => setSelectedKategorija(e.target.value)}
          style={{ height: "36px", padding: "0 10px", fontSize: "14px" }}>
          <option value="">Sve kategorije</option>
          {kategorije.map(k => <option key={k} value={k}>{k}</option>)}
        </select>
      </div>

      <div style={{ overflowY: "auto", height: "calc(100% - 110px)" }} id="katalog-tabela">
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={styles.cell}></th>
              <th style={styles.cell}>Rb.</th>
              <th style={{ ...styles.cell, width: "25%" }}>KATEGORIJA</th>
              <th style={{ ...styles.cell, width: "40%" }}>NAZIV</th>
              <th style={{ ...styles.cell, width: "20%" }}>STANDARD</th>
              <th style={styles.cell}></th>
            </tr>
          </thead>
          <tbody>
            {allData.map((item, i) => (
              <tr key={item.id} ref={el => rowRefs.current[item.id] = el}
                style={{ backgroundColor: checkedIds.includes(item.id) ? "#e8f4e8" : "", transition: "background-color 0.4s" }}>
                <td style={styles.cell}>
                  <input type="checkbox" checked={checkedIds.includes(item.id)}
                    onChange={() => handleCheckRow(item.id)} style={{ width: "25px" }} />
                </td>
                <td style={styles.cell}>{i + 1}.</td>
                <td style={styles.cell}>{item.kategorija}</td>
                <td style={{ ...styles.cell, textAlign: "left", paddingLeft: "8px" }}>{item.naziv}</td>
                <td style={styles.cell}>{item.standard}</td>
                <td style={{ ...styles.cell, cursor: "pointer" }} onClick={() => setDetaljiItem(item)}>
                  <img src={visibleImg} style={{ width: "25px" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
        <div style={{ fontWeight: "bold" }}>
          <div style={{ fontSize: "24px" }}>{checkedIds.length}</div>
          <div style={{ fontSize: "12px" }}>ODABRANO</div>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={() => setFolderDokumentCurrentState("")}>
            <Button activation={true} style={styles.button}>NAZAD</Button>
          </div>
          {checkedIds.length > 0 && (
            <div onClick={loading ? undefined : handleDodajKlik} style={{ opacity: loading ? 0.5 : 1 }}>
              <Button activation={true} style={styles.button}>DODAJ U FIRMU</Button>
            </div>
          )}
        </div>
      </div>

      {detaljiItem && (
        <LzoDetaljiModal item={detaljiItem} baseUrl={baseUrl} onClose={() => setDetaljiItem(null)} />
      )}

      {showKolicine && (
        <KolicineModal
          selectedItems={selectedItems}
          onConfirm={handleConfirmKolicine}
          onClose={() => setShowKolicine(false)}
        />
      )}
    </div>
  );
}

export default DodavanjePostojeciTabela;